import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';


// Components

import CommonHeaderContainer from '../../containers/ssap/CommonHeaderContainer';
import SsapNavBarContainer from '../../containers/ssap/SsapNavBarContainer';
import PagesContainer from '../../containers/ssap/PagesContainer';
import AgentPromotion from '../individualPortal/AgentPromotion';


const Ssap = props => {

    const {
        adjustedFlow,
        data: {
            currentPage
        },
        launchData: {
            consumer
        },
        environment: {
            isState
        },
        history
    } = props;

    const isCAP = consumer === 'CAP';
    const MainGridClass = classnames({
        'desktop:grid-col-8 desktop:grid-offset-2': !isCAP && isState.MN,
        'desktop:grid-col-9': isCAP || !isState.MN,
    });



    return (
        !isCAP
            ? <main className='usa-layout-docs usa-section main-section' id="main-content">
                <div className="grid-container grid-widescreen gi-grid-container">
                    <div className="grid-row mobile-wrapper--inverse">
                        <SsapNavBarContainer {...{ ...props, isShown: !isState.MN }} />
                        <div className={`usa-layout-docs__main ${MainGridClass} usa-prose`}>
                            {
                                currentPage !== -1 &&

                                <Fragment>
                                    <CommonHeaderContainer />
                                    <PagesContainer {...{ adjustedFlow, history }} />
                                </Fragment>
                            }
                        </div>
                    </div>
                </div>
                <AgentPromotion />
            </main>
            : <div className={`usa-layout-docs__main ${MainGridClass} usa-prose`}>
                {
                    currentPage !== -1 &&
                    <Fragment>
                        <CommonHeaderContainer />
                        <PagesContainer {...{ history }} />
                    </Fragment>
                }
            </div>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    data: state.ssap.data,
    launchData: state.ssap.launchData
});


export default connect(mapStateToProps)(Ssap);
